/* eslint-disable */
import { createStyles } from "@material-ui/styles";
import { Theme } from "@material-ui/core";

export const styles = (theme: Theme) =>
  createStyles({
    root: {
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      marginBottom: 50,
      marginTop: 64,
    },
    header: {
      padding: "20px 32px 12px 32px",
      width: "100%",
      display: "flex",
      alignItems: "center",
      justifyContent: "space-between",
    },
    headerTitleGroup: {
      display: "flex",
      alignItems: "center",
    },
    headerTitle: {
      fontSize: "22px",
      fontWeight: "bold",
    },
    buttonContainer: {
      display: "flex",
      alignSelf: "flex-start", 
      marginBottom: "12px",
      justifyContent: "space-evenly",
    },
    buttonBase: {
      display: "flex",
      width: "100%",
      flexDirection: "row",
      alignItems: "flex-start",
      padding: "0px 0px 0px 32px",
      maxHeight: "45px"
    },
    setPasswordExpButton:{
      display: "flex",
      width: "100%",
      flexDirection: "row",
      alignItems: "flex-start",
      padding: "0px 0px 0px 32px",
      maxHeight: "45px"
    },
    tableContainer: {
      padding: "0px 32px",
      width: "100%",
    },
    modal: {
      alignItems: "flex-start",
      justifyContent: "center",
      display: "flex",
    },
    modalBox: {
      outline: "none",
      position: "relative",
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      backgroundColor: theme.palette.background.paper,
      border: "1px solid",
      borderColor: "grey",
      borderRadius: "10px",
      width: "600px",
      padding: "24px",
      margin: "70px 32px",
      maxHeight: "calc(100% - 64px)",
      overflowY: "auto",
    },
    modalHeader: {
      marginBottom: "12px",
    },
    modalInputLabel: {
      color: theme.palette.primary.main,
    },
    modalButtonBase: {
      display: "flex",
      width: "100%",
      flexDirection: "row",
      alignItems: "center",
      marginTop: "12px",
      paddingLeft: "26px",
    },
    modalButtons: {
      marginRight: 12,
      width: 100,
      textTransform: "none",
    },
    btnCancel: {
      backgroundColor: "#bfbfbf",
      color: "#fff",
      textTransform: "none",
      width: 100,
      "&:hover": {
        backgroundColor: "#999999",
      },
    },
    fieldItem: {
      display: "flex",
      flexDirection: "row",
      alignItems: "center",
      justifyContent: "space-between",
      marginBottom: "12px",
      width: "500px",
    },
    fieldContent: {
      display: "flex",
    },
    comboBox: {
      display: "flex",
      width: "100%",
    },
    tableCell: {
      maxWidth: 260,
      textOverflow: "ellipsis",
      whiteSpace: "nowrap",
      overflow: "hidden",
      "&:last-child": {
        paddingLeft: theme.spacing(1),
        width: 88,
      },
    },
    tableCellMinWidth: {
      minWidth: 180,
    },
    tableCellWidth: {
      width: 193,
    },
    option: {
      paddingLeft: theme.spacing(1),
      "&:hover": {
        cursor: "pointer",
        backgroundColor: "rgba(0, 0, 0, 0.04)",
      },
    },
    textField: {
      position: "relative",
      marginBottom: "12px",
    },
    helperText: {
      position: "absolute",
      bottom: "-22px",
      color: "#f44336",
    },
    paginationRoot: {
      height: "60px",
    },
  });
